import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import './meus-dados.css';
import { UsersService } from '../../services/user';

import {
  HeaderShelf,
  SidebarRoundedIcons,
  Footer
} from '../../components';

export default class ViewMeusDados extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profile: {
        name: '',
        email: '',
        phone: '',
        cpf: '',
        login: ''
      },
      acceptedPrivacyPolice: false,
      userOrganizations: [],
      loading: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleLinkOrganization = this.handleLinkOrganization.bind(this);
    this.maskCpf = this.maskCpf.bind(this);
    this.validateCpf = this.validateCpf.bind(this);
  }

  componentDidMount() {
    this.loadUserData();
  }

  async loadUserData() {
    try {
      const userDetails = await Sdk.Api.dynamic.bridge('/auth/v1.0/user/me', null, 'GET');
      
      this.setState({
        profile: {
          name: userDetails.detail.name || '',
          email: userDetails.detail.email || '',
          phone: userDetails.detail.phone || '',
          cpf: userDetails.detail.cpf || '',
          login: userDetails.detail.login || ''
        },
        acceptedPrivacyPolice: userDetails.detail.acceptedPrivacyPolice || false,
        userOrganizations: userDetails.projects || [],
        loading: false
      });
    } catch (error) {
      console.error('Erro ao carregar dados do usuário:', error);
      this.setState({ loading: false });
    }
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    
    if (name === 'cpf') {
      if (value.length >= 15) return;
    }

    this.setState({
      profile: {
        ...this.state.profile,
        [name]: value
      }
    });
  }

  maskCpf(cpf) {
    if (!cpf) return '';
    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return cpf;
  }

  validateCpf(cpf) {
    if (!cpf) return false;
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return false;
    
    // Validação básica de CPF
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(9))) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(10))) return false;

    return true;
  }

  async handleSave() {
    try {
      const { profile } = this.state;
      
      await Sdk.Api.dynamic.bridge('/auth/v1.0/user/me', {
        name: profile.name,
        email: profile.email,
        phone: profile.phone,
        cpf: profile.cpf.replace(/\D/g, ''),
        acceptedPrivacyPolice: this.state.acceptedPrivacyPolice
      }, 'PUT');

      alert('Dados salvos com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar dados:', error);
      alert('Erro ao salvar dados. Tente novamente.');
    }
  }

  handleChangePassword() {
    // Implementar navegação para tela de alteração de senha
    console.log('Alterar senha');
  }

  handleLinkOrganization() {
    // Implementar sincronização de organizações
    console.log('Sincronizar organizações');
  }

  async handleLogout() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  render() {
    const { profile, acceptedPrivacyPolice, userOrganizations, loading } = this.state;
    
    if (loading) {
      return (
        <div className="rdp-react-template-view-meus-dados">
          <div className="rdp-react-template-view-meus-dados-loading">
            <div className="rdp-react-template-view-meus-dados-loader"></div>
          </div>
        </div>
      );
    }

    const isValidCpf = this.validateCpf(profile.cpf);
    const canSave = profile.name && profile.email && isValidCpf && acceptedPrivacyPolice;

    return (
      <div className="rdp-react-template-view-meus-dados">
        <div className="rdp-react-template-view-meus-dados-header">
          <HeaderShelf
            onSignOut={() => this.handleLogout()}
            renderSearch={false}
          />
        </div>

        <div className="rdp-react-template-view-meus-dados-sidebar">
          <SidebarRoundedIcons />
        </div>

        <div className="rdp-react-template-view-meus-dados-main">
          <div className="rdp-react-template-view-meus-dados-container">
            <div className="rdp-react-template-view-meus-dados-header-section">
              {/* <button 
                className="rdp-react-template-view-meus-dados-back-btn"
                onClick={() => this.onBack()}
              >
                ← Voltar
              </button> */}
              <h1 className="rdp-react-template-view-meus-dados-title">Meus Dados</h1>
            </div>

            <div className="rdp-react-template-view-meus-dados-form">
              <div className="rdp-react-template-view-meus-dados-field">
                <label className="rdp-react-template-view-meus-dados-label">
                  Nome completo *
                </label>
                <input
                  type="text"
                  name="name"
                  value={profile.name}
                  onChange={this.handleInputChange}
                  placeholder="Digite seu nome"
                  className="rdp-react-template-view-meus-dados-search-input"
                  required
                />
              </div>

              <div className="rdp-react-template-view-meus-dados-field">
                <label className="rdp-react-template-view-meus-dados-label">
                  CPF *
                </label>
                <input
                  type="text"
                  name="cpf"
                  value={this.maskCpf(profile.cpf)}
                  onChange={this.handleInputChange}
                  placeholder="Digite seu CPF"
                  className="rdp-react-template-view-meus-dados-search-input"
                  required
                />
              </div>

              <div className="rdp-react-template-view-meus-dados-field">
                <label className="rdp-react-template-view-meus-dados-label">
                  E-mail *
                </label>
                <input
                  type="email"
                  name="email"
                  value={profile.email}
                  onChange={this.handleInputChange}
                  placeholder="Digite seu email"
                  className="rdp-react-template-view-meus-dados-search-input"
                  required
                />
              </div>

                <div className="rdp-react-template-view-meus-dados-field">
                <label className="rdp-react-template-view-meus-dados-label">
                  Telefone
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={profile.phone}
                  onChange={this.handleInputChange}
                  placeholder="Digite seu telefone"
                  className="rdp-react-template-view-meus-dados-search-input"
                />
              </div>

              <div className="rdp-react-template-view-meus-dados-organizations">
                <div className="rdp-react-template-view-meus-dados-organizations-header">
                  <label className="rdp-react-template-view-meus-dados-label">
                    Organizações
                  </label>
                  <button
                    className="rdp-react-template-view-meus-dados-sync-btn"
                    onClick={this.handleLinkOrganization}
                    disabled={!profile.cpf}
                  >
                  </button>
                </div>
                
                {userOrganizations.length > 0 ? (
                  userOrganizations.map((org, index) => (
                    <div key={index} className="rdp-react-template-view-meus-dados-organization">
                      <span>{org.name}</span>
                      <span className="rdp-react-template-view-meus-dados-organization-status">✓</span>
                    </div>
                  ))
                ) : (
                  <div className="rdp-react-template-view-meus-dados-organization-empty">
                    <span>Nenhuma organização vinculada</span>
                  </div>
                )}
              </div>

              <div className="rdp-react-template-view-meus-dados-privacy">
                <label className="rdp-react-template-view-meus-dados-checkbox-container">
                  <input
                    type="checkbox"
                    checked={acceptedPrivacyPolice}
                    onChange={(e) => this.setState({ acceptedPrivacyPolice: e.target.checked })}
                    className="rdp-react-template-view-meus-dados-checkbox"
                  />
                  <span className="rdp-react-template-view-meus-dados-privacy-text">
                    Aceito a{' '}
                    <a
                      href="https://www.sp.senac.br/politica-de-privacidade"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rdp-react-template-view-meus-dados-privacy-link"
                    >
                      Política de Privacidade
                    </a>
                    {' '}do Senac São Paulo
                  </span>
                </label>
              </div>

              <div className="rdp-react-template-view-meus-dados-actions">
                <button
                  className="rdp-react-template-view-meus-dados-btn rdp-react-template-view-meus-dados-btn-secondary"
                  onClick={this.handleChangePassword}
                >
                  <div className="rdp-react-template-view-meus-dados-btn-icon-unlock"></div>
                  <span>                    
                    Alterar senha
                    </span> 
                </button>
                
                <button
                  className="rdp-react-template-view-meus-dados-btn rdp-react-template-view-meus-dados-btn-primary"
                  onClick={this.handleSave}
                  disabled={!canSave}
                >
                  <div className="rdp-react-template-view-meus-dados-btn-icon-password"></div>
                  <span>Salvar Dados</span>
                </button>
              </div>

              <div className="rdp-react-template-view-meus-dados-logout">
                <button
                  className="rdp-react-template-view-meus-dados-btn rdp-react-template-view-meus-dados-btn-logout"
                  onClick={() => this.handleLogout()}
                >
                  Sair
                </button>
                {/* <p className="rdp-react-template-view-meus-dados-delete-info">
                  A exclusão da conta pode ser solicitada pela opção 'Fale Conosco'.
                </p> */}
              </div>
            </div>
          </div>
          <Footer/>
        </div>
      </div>
    );
  }
}